import { useState, type FormEvent } from 'react';
import { useAuthStore } from '@/auth/authStore';
import { api, ApiError } from '@/api/client';

export function LoginPage() {
  const setSession = useAuthStore((s) => s.setSession);
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const env = await api.login({ identifier: identifier.trim(), password });
      if (env.user.role !== 'ADMIN' && env.user.role !== 'MODERATOR') {
        setErr('This account does not have admin access.');
        setBusy(false);
        return;
      }
      setSession(env.token, env.user);
    } catch (e) {
      if (e instanceof ApiError) setErr(e.message || e.code);
      else setErr('Network error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(ellipse at 20% 0%, rgba(155,93,229,0.2), transparent 60%),' +
          'radial-gradient(ellipse at 80% 100%, rgba(34,211,238,0.12), transparent 60%),' +
          'var(--bg-deep)',
        padding: 20,
      }}
    >
      <form
        onSubmit={submit}
        className="card"
        style={{ width: '100%', maxWidth: 360, padding: 28 }}
      >
        <div
          className="display"
          style={{
            fontSize: 22,
            color: 'var(--c-cyan)',
            marginBottom: 6,
            letterSpacing: '0.08em',
          }}
        >
          DON’T MISS
        </div>
        <div className="tag" style={{ marginBottom: 18, color: 'var(--ink-dim)' }}>
          ADMIN CONSOLE
        </div>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
          <span className="tag" style={{ fontSize: 9 }}>EMAIL OR USERNAME</span>
          <input
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            autoFocus
            autoComplete="username"
            required
            minLength={3}
          />
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
          <span className="tag" style={{ fontSize: 9 }}>PASSWORD</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {err && (
          <div
            style={{
              padding: '8px 10px',
              borderRadius: 8,
              background: 'rgba(230,57,70,0.16)',
              border: '1px solid rgba(230,57,70,0.4)',
              color: 'var(--c-red)',
              fontSize: 12,
              marginBottom: 12,
            }}
          >
            {err}
          </div>
        )}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={busy}
          style={{ width: '100%', padding: '12px 18px', fontSize: 14 }}
        >
          {busy ? 'SIGNING IN…' : 'SIGN IN'}
        </button>

        <div
          style={{
            marginTop: 14,
            fontSize: 10,
            color: 'var(--ink-dim)',
            textAlign: 'center',
            fontFamily: 'var(--f-mono)',
          }}
        >
          server: {import.meta.env.VITE_SERVER_URL ?? 'http://localhost:8787'}
        </div>
      </form>
    </div>
  );
}
